import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        puntiDiInteresse: []
    },
    getters: {
        puntiDiInteresseGeojson: (state: any) => ({
            type: 'FeatureCollection',
            features: state.puntiDiInteresse.map((puntoDiInteresse: any) => ({
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [puntoDiInteresse.longitudine, puntoDiInteresse.latitudine]
                },
                properties: {
                    id: puntoDiInteresse.id,
                    link: puntoDiInteresse.link
                }
            }))
        })
    },
    mutations: {
        CARICA_PUNTI_DI_INTERESSE: (state: any, payload: any) => {
            state.puntiDiInteresse = payload
        }
    },
    actions: {
        async caricaPuntiDiInteresse({commit}: any) {
            try {
                const response = await Vue.axios.get('/api_mapplants/punti_di_interesse.json')
                commit('CARICA_PUNTI_DI_INTERESSE', response.data)
            } catch (err) {
                console.error(err)
            }
        }
    }
}
